import { 
    TURN_ON_SCREEN_SHARING,
    TURN_OFF_SCREEN_SHARING,
    TURN_OFF_SCREEN_SHARING_TOAST,
    TURN_ON_SCREEN_SHARING_TOAST,
    TURN_ON_HOST_CAMERA,
    TURN_OFF_HOST_CAMERA,
    TURN_ON_HOST_MIC,
    TURN_OFF_HOST_MIC,
    SHOW_SETTINGS_PAGE, 
    HIDE_SETTINGS_PAGE,
    TURN_OFF_CAMERA,
    TURN_OFF_MIC,
    TURN_ON_CAMERA,
    TURN_ON_MIC,
    SHOW_ATTENDEE_COUNT,
    SET_PASS_LOGIN,   
    SET_OFF_RECORD,
    SET_START_RECORD,
    SET_UID,
    SET_COPRESENTER_INFO,
    SET_COPRESENTER_UIDS,
    SET_ROLE_COPRESENTER,
    CHECK_RECORD,
    OFF_CHECK_RECORD,
    COPRESENTINFO,
    TOAST_MESSAGE,
    SET_IS_SHOW_ATTENDEE_LIST, 
    CHANGEVIDEO,
    CHANGEAUDIO,
    SET_CAM_BEFORE_SCREEN_SHARE,
    MUTECOPRESENTERUID,
    MUTEDBYHOST,
    SET_ROTATE_DEGREE,
    SET_PINNED_LAYOUT_UID,
    USEPORTRAIT} from './controls.actionTypes'
   

const initialState = {
    isShowSettings: false,
    isHostPassLogin: false,
    usePortrait: false,
    rotateDegree: 0,
    roleCopresenter: false,
    isCameraOn: true,
    cameraOnBeforeScreenShare: true,
    isMicOn: true,
    isScreenSharing: false,
    screenSharingToast: false,
    isHostCameraOn: true,
    isHostMicOn: true,
    showAttendeeCount:true,
    isRecord: false,
    uid:-1,
    coPresenterInfo: [],
    coPresenterUids: [],
    isShowAttendeeList:false,
    toastMess: '',
    copresenterNames:{
        "firstName":'',
        "lastName":''
    },
    copresenterMuteUid: -1,
    isMutedByHost: false,
    newVideoStream: null,
    newAudioStream: null,
    pinnedLayoutUid: null,
}

export default function controls(state = initialState, action: any) {

    switch (action.type) {
        case USEPORTRAIT: {
            return {
                ...state,
                usePortrait: action.payload
            };
        }
        case SHOW_SETTINGS_PAGE:{
            return {
                ...state,
                isShowSettings: true
            };
        }

        case HIDE_SETTINGS_PAGE:{
            return {
                ...state,
                isShowSettings: false
            };
        }

        case TURN_OFF_CAMERA:{
            return {
                ...state,
                isCameraOn: false
            };
        }

        case TURN_ON_CAMERA:{
            return {
                ...state,
                isCameraOn: true
            };
        }

        case TURN_OFF_HOST_CAMERA:{
            return {
                ...state,
                isHostCameraOn: false
            };
        }

        case TURN_ON_HOST_CAMERA:{
            return {
                ...state,
                isHostCameraOn: true
            };
        }

        case TURN_ON_MIC:{
            return {
                ...state,
                isMicOn: true
            };
        }

        case TURN_OFF_MIC:{
            return {
                ...state,
                isMicOn: false
            };
        }

        case TURN_OFF_SCREEN_SHARING:{
            return {
                ...state,
                isScreenSharing: false
            };
        }

        case TURN_ON_SCREEN_SHARING:{
            return {
                ...state,
                isScreenSharing: true
            };
        }

        case SET_CAM_BEFORE_SCREEN_SHARE:{
            return {
                ...state,
                cameraOnBeforeScreenShare: action.payload
            };
        }

        case TURN_OFF_SCREEN_SHARING_TOAST:{
            return {
                ...state,
                screenSharingToast: false
            };
        }

        case TURN_ON_SCREEN_SHARING_TOAST:{
            return {
                ...state,
                screenSharingToast: true
            };
        }

        case TURN_ON_HOST_MIC:{
            return {
                ...state,
                isHostMicOn: true
            };
        }

        case TURN_OFF_HOST_MIC:{
            return {
                ...state,
                isHostMicOn: false
            };
        }

        case SET_PASS_LOGIN:{
            return {
                ...state,
                isHostPassLogin: true
            };
        }

        case SET_ROLE_COPRESENTER: {
            return {
                ...state,
                roleCopresenter: action.payload
            }
        }

        case SHOW_ATTENDEE_COUNT:{
            return {
                ...state,
                showAttendeeCount: action.payload
            }
        }

        case SET_ROTATE_DEGREE:{
            return {
                ...state,
                rotateDegree: action.payload
            };
        }

        case SET_OFF_RECORD:{
            return {
                ...state,
                isRecord: false
            };
        }

        case SET_START_RECORD:{
            return {
                ...state,
                isRecord: true
            };
        }

        case SET_UID:{
            return {
                ...state,
                uid: action.payload
            }
        }

        case SET_COPRESENTER_INFO:{
            return {
                ...state,
                coPresenterInfo: action.payload
            }
        }
	
	 case SET_COPRESENTER_UIDS:{
            return {
                ...state,
                coPresenterUids: action.payload
            }
        }

        case SET_IS_SHOW_ATTENDEE_LIST:{
            return {
                ...state,
                isShowAttendeeList: action.payload
            };
        }
        case CHECK_RECORD:{
            return {
                ...state,
                checkRecord: true
            }
        }

        case OFF_CHECK_RECORD:{
            return {
                ...state,
                checkRecord: false
            }
        }
        case TOAST_MESSAGE:{
            return {
                ...state,
                toastMess: action.payload
            }
        }
        case COPRESENTINFO: {
            return {
                ...state,
                copresenterNames: action.payload
            }
        }
        case MUTECOPRESENTERUID: {
            return {
                ...state,
                copresenterMuteUid: action.payload
            }
        }
        case MUTEDBYHOST: {
            return {
                ...state,
                isMutedByHost: action.payload
            }
        }
        case CHANGEVIDEO: {
            return {
                ...state,
                newVideoStream: action.payload
            }
        }
        case CHANGEAUDIO: {
            return {
                ...state,
                newAudioStream: action.payload
            }
        }
        case SET_PINNED_LAYOUT_UID: {
            return {
                ...state,
                pinnedLayoutUid: action.payload
            }
        }
        default:
        return state;

       
    }

}